class BarfCalculator extends HTMLElement {
  constructor() {
    super();
    this.submitForm = this.submitForm.bind(this);
  }

  connectedCallback() {
    this.formElement = this.querySelector('form');
    this.minResultElement = this.querySelector('.result-min');
    this.maxResultElement = this.querySelector('.result-max');
    this.formElement.addEventListener('submit', this.submitForm);
  }

  submitForm(event) {
    event.preventDefault();

    this.getCheckedPetType(event);
    this.getPetWeight(event);
    this.defineWeightFactors();
    this.calculateFeedingAdvice();
    this.placeResultsIntoDOM();
  }

  getCheckedPetType(event) {
    let inputPetType = event.target.querySelectorAll('input[type="radio"]');

    for (let input of inputPetType) {
      if (input.checked) {
        this.checkedPetType = input.value;       
      }
    }
  }

  getPetWeight(event) {
    this.petWeight = event.target.querySelector('[id="pet-weight"]').value;
  }

  defineWeightFactors() {
    switch(this.checkedPetType) {
      case 'adult-dog':
      case 'adult-cat':
        this.minWeightFactor = 0.02;
        this.maxWeightFactor = 0.03;
        break;
      case 'puppy':
      case 'kitten':
        this.minWeightFactor = 0.04;
        this.maxWeightFactor = 0.06;
        break;
      default:
        console.error('For this checkedPetType is no factor for calculation defined!');
    }
  }

  calculateFeedingAdvice() {
    this.minResult = Math.round(this.petWeight * this.minWeightFactor * 1000);
    this.maxResult = Math.round(this.petWeight * this.maxWeightFactor * 1000);
  }

  placeResultsIntoDOM() {
    this.minResultElement.innerText = this.minResult;
    this.maxResultElement.innerText = this.maxResult;
  }
}

customElements.define("barf-calculator", BarfCalculator);